import React from "react";

function TypingIndicator({ typingUsers }) {
    if (!typingUsers || typingUsers.length === 0) return null;
    return (
        <div className="text-gray-400 italic text-[11px] sm:text-sm">
            {typingUsers.join(", ")} {typingUsers.length > 1 ? "are" : "is"} typing...
        </div>
    );
}

export default TypingIndicator;


